function noop() {}
if (!window.console) {
    window.console = {
        debug: noop,
        log: noop,
        info: noop,
        warn: noop,
        error: noop
    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/console.js